import Pikaday from 'pikaday';

export function init() {
	const inputs = Array.from(document.querySelectorAll('.js-datepicker'));

	inputs.forEach(function createDatePicker(input) {
		new Pikaday({
			field: input,
			format: 'DD/MM/YYYY',
			minDate: new Date(),
		});

		// Prevent onscreen keyboard on iOS, Android, etc.
		input.setAttribute('readonly', true);
	});
}
